import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { PlaybackScheduleDTO } from '../../../services/api/api';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';

@Component({
  selector: 'sb-comp-schedule-level-edit',
  templateUrl: './schedule-level-edit.component.html',
  styleUrls: ['./schedule-level-edit.component.scss'],
  standalone: false,
})
export class ScheduleLevelEditComponent implements OnInit {
  form: UntypedFormGroup;
  isInModalContext: boolean;
  priority: number;
  schedule: PlaybackScheduleDTO;

  constructor(private modalService: ModalNavigationService) {
    this.form = new UntypedFormGroup(
      {
        Priority: new UntypedFormControl('', [Validators.required]) /*,
        Title: new FormControl('', [
            Validators.required
          ]
        ),
        Description: new FormControl('', []
        ),*/,
      },
      [this.isBetweenNumbers]
    );
  }

  get Priority() {
    return this.form.get('Priority');
  }

  /*
    get Title() {
      return this.form.get('Title');
    }

    get Description() {
      return this.form.get('Description');
    }
  */
  isBetweenNumbers: ValidatorFn = (fg: UntypedFormGroup) => {
    const levelNumber = fg.get('Level').value;

    if (levelNumber >= 0 && levelNumber <= 100) {
      return null;
    }
    return { isBetweenNumbers: 'true' };
  };

  private registerFormChangesListener() {
    this.Priority.valueChanges.subscribe(value => {
      this.priority = value;
    });
    /*
    this.Title.valueChanges.subscribe(value => {
      this.level.name = value;
    });
    this.Description.valueChanges.subscribe(value => {
      this.level.description = value;
    });*/
  }

  updateForm() {
    this.Priority.setValue(this.priority);
    this.Priority.disable();
    /*
    this.Title.setValue(this.level.name);
    this.Description.setValue(this.level.description);
  */
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.priority = this.modalService.getCurrentNavigation().data.priority;
      this.schedule = this.modalService.getCurrentNavigation().data.scheduleData;
    }
    if (this.priority) {
      this.updateForm();
    }
    this.registerFormChangesListener();
  }

  sendLevel() {
    this.modalService.result(this.priority);
  }
}
